<template>
    <div>
        <v-checkbox v-if="optional"
            class="checkbox-plate"
            style="margin-top: 0; height: 25px;"
            :label="genitiveLabel ? ('Без ' + genitiveLabel) : 'Отсутствует'"
            :disabled="isDisabled"
            v-model="noField"
            @change="() => {
                this.name = this.noField ? null : this.name;
                this.$emit('update:noField', noField);
            }"
        />
        <v-text-field
            v-model="name"
            :rules="computedRules"
            :label="label"
            v-if="!(optional && noFieldValue) || isDisabled"
            @keyup.native="name = removeSymbols(name)"
            @blur.native="name.trim()"
            @blur="formatName"
            :required="isRequired"
            :disabled="isDisabled"
        />
    </div>
</template>

<script>
    export default {
        props: {
            value: '',
            label: '',
            rules: {
                type: Array,
                default: () => [],
            },
            isDisabled: {
                default: false
            },
            optional: {
                default: false
            },
            noField: false,
            genitiveLabel: null,
            allowDigits: {
                default:false
            },
            allowAll: {
                default:false
            },
            allowLatinAndRussian: {
                default: false,
            },
            isRequired: {
                default: true,
            },
        },
        data: () => ({
            name: null,
            noFieldValue: false,
            internalRules: {
                required: v => !!v || 'Обязательное поле',
                russianLetters: v => { if (!v) return true; return (/^[А-ЯЁа-яё\- ]+$/.test(v) || 'Допускаются только русские буквы') },
                russianLettersWithDigits: v => { if (!v) return true; return (/^[0-9А-ЯЁа-яё\- ]+$/.test(v) || 'Допускаются только цифры и русские буквы')},
                russianAndLatinLetters: v => { if (!v) return true; return (/^[A-Za-zА-ЯЁа-яё\- ]+$/.test(v) || 'Допускаются только латинские и русские буквы')},
            },
        }),

        computed: {
            textRules() {
                let res = [];
                if (this.isRequired) {
                    res = [this.internalRules.required];
                }
                if (this.allowLatinAndRussian) {
                    res.push(this.internalRules.russianAndLatinLetters);
                } else {
                    if (this.allowDigits) {
                        res.push(this.internalRules.russianLettersWithDigits);
                    }
                    if (!this.allowAll) {
                        res.push(this.internalRules.russianLetters);
                    }
                }
                return res;
            },

            computedRules() {
                if (this.isDisabled || (this.optional && this.noFieldValue)) return [];
                return [...this.textRules, ...this.rules];
            }
        },

        mounted: function () {
            this.noFieldValue = this.noField ? this.noField : false;
            this.name = this.value ? this.value : null;
        },

        watch: {
            value(val) {
                this.name = val;
            },

            name(val) {
                this.$emit("input", val);
                this.$emit("change", val);
            },

            noField(val) {
                this.noFieldValue = val;
            }
        },

        methods: {
            capitalize: function (val) {
                if (!val) return '';
                return val
                    .toString()
                    .toLowerCase()
                    .split(' ')
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join(' ')
                    .split('-')
                    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                    .join('-');
            },

            removeSymbols: function (val) {
                if (!val) return '';
                const textRegex = this.allowDigits ? /[^0-9A-Za-zА-ЯЁа-яё\- ]/g : /[^A-Za-zА-ЯЁа-яё\- ]/g;
                val = val
                    .toString()
                    .replace(/[ ]+/g, ' ')
                    .replace(/[-]+/g, '-')
                    .replace(/^[ |-]/g, '')
                    .replace(/ -/g, '-')
                    .replace(/- /g, '-');
                if (!this.allowAll) {
                    val = val.replace(textRegex, '');
                }
                return val;
            },

            formatName() {
                this.name = this.capitalize(this.name);
            }
        }
    }
</script>

<style scoped>
    .checkbox-plate >>> .v-input__control {
        height: 25px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/fields/Name.vue